import FundingOptions from "./FundingOptions.svg";

export default FundingOptions;
